// removed by extract-text-webpack-plugin
module.exports = {"FlipCard":"Cards__FlipCard__33PG9"};